import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { updateCurrentUser } from "../store/current_user"
import { fetchCurrentUser } from "../api/users"
import { AuthState } from '@aws-amplify/ui-components'

export function useCurrentUserUpdate(authState: AuthState) {
  const dispatch = useDispatch()
  const location = useLocation();
  
  useEffect(() => {
    async function setCurrentUser() {
      const user = await fetchCurrentUser()
      dispatch(updateCurrentUser(user))
    }
    setCurrentUser()
  }, [location, dispatch, authState])
}